export class SetVideoCanBePlayed {
    public static readonly type = '[EaVideoPlayer] SetVideoCanBePlayed';
    constructor(public canBePlayed: boolean) { }
}

export class ToggleMute {
    public static readonly type = '[EaVideoPlayer] ToggleMute';
}

export class SetVideoPlaying {
    public static readonly type = '[EaVideoPlayer] SetVideoPlaying';
    constructor(public isPlaying: boolean) { }
}

export class SetVideoPlaybackError {
    public static readonly type = '[EaVideoPlayer] SetVideoPlaybackError';
    constructor(public error: string | undefined) { }
}

export class SetCurrentVideoTimeSeconds {
    public static readonly type = '[EaVideoPlayer] SetCurrentVideoTimeSeconds';
    constructor(public seconds: number) { }
}
